import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { OriginatorsState } from './types';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: OriginatorsState = {
    originators:[],
};


export const originators: Module<OriginatorsState,RootState> = {
    state,
    getters,
    actions,
    mutations
};